var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_12760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.31836C7.97603 6.31836 6.33203 7.95879 6.33203 9.97838C6.33203 11.998 7.97603 13.6424 10 13.6424C12.024 13.6424 13.672 11.998 13.672 9.97838C13.672 7.95879 12.024 6.31836 10 6.31836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.536 0H4.464C2.004 0 0 1.99964 0 4.4543V15.5022C0 17.9609 2.004 19.9565 4.464 19.9565H15.536C18 19.9565 20 17.9609 20 15.5022V4.4543C20 1.99964 18 0 15.536 0ZM10 16.4442C6.428 16.4442 3.52 13.5425 3.52 9.97826C3.52 6.41403 6.428 3.51634 10 3.51634C13.572 3.51634 16.48 6.41403 16.48 9.97826C16.48 13.5425 13.572 16.4442 10 16.4442ZM16.616 4.68978C15.86 4.68978 15.244 4.07911 15.244 3.32476C15.244 2.5704 15.86 1.95574 16.616 1.95574C17.372 1.95574 17.988 2.5704 17.988 3.32476C17.988 4.07911 17.372 4.68978 16.616 4.68978Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_12760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6f0113a122bd5156b50d4640e3ad502b.svg";
export { ForwardRef as ReactComponent };